import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { StyledProductFeaturesList } from './styled';
import ProductFeaturesListItem from './ProductFeaturesListItem';
import { CONTAINER_TEST_ID } from './constants';
var ProductFeaturesList = function ProductFeaturesList(_ref) {
  var features = _ref.features,
    productKey = _ref.productKey,
    className = _ref.className,
    includedAreaLabel = _ref.includedAreaLabel,
    excludedAreaLabel = _ref.excludedAreaLabel,
    isMobile = _ref.isMobile;
  var baseTestId = "product-".concat(productKey);
  /**
   * PMM ran the experiment to only show isIncluded features for CS/P on mobile
   * Making dumb component scalable if we introduce new product/feature as well
   * https://chegg.atlassian.net/browse/CW-1849
   */
  var updatedFeatures = isMobile ? features.filter(function (feature) {
    return feature.isIncluded;
  }) : features;
  return /*#__PURE__*/React.createElement(StyledProductFeaturesList, {
    className: className,
    "data-test": CONTAINER_TEST_ID
  }, updatedFeatures.map(function (feature) {
    return /*#__PURE__*/React.createElement(ProductFeaturesListItem, _extends({}, feature, {
      baseTestId: baseTestId,
      key: feature.name,
      includedAreaLabel: includedAreaLabel,
      excludedAreaLabel: excludedAreaLabel
    }));
  }));
};
export default ProductFeaturesList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/ProductFeaturesList/ProductFeaturesList.js
// module id = 4063
// module chunks = 11